var R = /* @__PURE__ */ ((I) => (I.CAPTION = "caption", I.BODY = "body", I.SUBTITLE = "subtitle", I.TITLE = "title", I))(R || {}), s = /* @__PURE__ */ ((I) => (I.WIDE = "wide", I.STRONGER = "stronger", I.STRONGER_WIDE = "stronger-wide", I.STRONGEST = "strongest", I.STRONGEST_WIDE = "strongest-wide", I.MEDIUM = "m", I.LARGE = "l", I.MOBILE = "mobile", I))(s || {}), S = /* @__PURE__ */ ((I) => (I.H1 = "h1", I.H2 = "h2", I.H3 = "h3", I.H4 = "h4", I.H5 = "h5", I.H6 = "h6", I.DIV = "div", I.PARAGRAPH = "p", I.SPAN = "span", I))(S || {});
export {
  S as TypographyElement,
  s as TypographyModifier,
  R as TypographyVariant
};
